// Simple first-order low-pass + high-pass cascade (Butterworth-like band-pass).
export class BandPassFilter {
  constructor(lowCutoff, highCutoff, sampleRate) {
    const dt = 1 / sampleRate;
    const rcLow = 1 / (2 * Math.PI * highCutoff);
    this.alphaLow = dt / (rcLow + dt);
    const rcHigh = 1 / (2 * Math.PI * lowCutoff);
    this.alphaHigh = rcHigh / (rcHigh + dt);
    this.reset();
  }

  reset() {
    this.lowPassPrev = 0;
    this.highPassPrev = 0;
    this.prevInput = 0;
  }

  process(input) {
    this.lowPassPrev = this.lowPassPrev + this.alphaLow * (input - this.lowPassPrev);
    const highPass = this.alphaHigh * (this.highPassPrev + this.lowPassPrev - this.prevInput);
    this.highPassPrev = highPass;
    this.prevInput = this.lowPassPrev;
    return highPass;
  }
}
